import { Input } from 'components/elements';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export default function InformationField() {
  const { t } = useTranslation();
  return (
    <FullContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            name="transactionAt"
            type="date-time"
            label={t('common:transaction_at')}
            placeholder={t('common:transaction_at')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            name="description"
            type="text-area"
            label={t('common:description')}
            placeholder={t('common:description')}
          />
        </HalfContainer>
      </SectionContainer>
    </FullContainer>
  );
}
